import React from 'react';
import './App.css';
import 'react-circular-progressbar/dist/styles.css';

import './styles/global';

import {Routes} from './routes';

function App() {

  return(
    <Routes/> 
  )
}

export default App;
